<template lang="pug">
div
	portal(to="full-width" :disabled="!weblog.isVideoBlog")
		v-row(no-gutters)
			v-col.grow
				h1.mb-0 {{weblog.title}}
				.subtitle.grey--text(v-if="page === 1" )
					v-chip.px-1.mr-2.flex-grow-0.flex-shrink-0(label x-small color="grey lighten-2" v-if="weblog.category == 'advertorial'") gesponsord
					nuxt-link(:to="localePath({name:'profile-slug', params: {slug: weblog.author.slug}})" :title="weblog.author.username" v-if="weblog.category !== 'advertorial' && isNL") {{weblog.author.username}}
					span(v-else-if="$i18n.locale === 'de-DE'") {{weblog.author.username}}
					|
					|
					template(v-if="!weblog.isPublishDateHidden") {{$t('page.weblog.message:published.at.{date}', {date: $dayjs(weblog.publishDate).format('DD MMMM YYYY')})}}
						template(v-if="weblog.category !== 'advertorial'") ·
					template(v-if="weblog.editDate") {{$t('page.weblog.message:edited.at.{date}', {date: $dayjs(weblog.editDate).format('DD MMMM YYYY')})}}
						template(v-if="weblog.category !== 'advertorial'") ·
					a.grey--text(:title="$t('page.weblog.message:link.to.reply.title')" href="#reacties" v-if="weblog.category !== 'advertorial' && isNL")  {{$tc('page.weblog.message:reply.{count}', weblog.replyCount, {count: weblog.replyCount})}}
			v-col.shrink.text-no-wrap(v-if="$store.state.user.id && weblog.category !== 'advertorial' && isNL")
				v-checkbox.mt-0(v-model="weblog.isFavorite" on-icon="favorite" off-icon="favorite_border" color="#ff5a5e" :label="`${weblog.followerCount}`" hide-details)
		v-responsive.mb-3(:aspect-ratio="16/9" v-if="weblog.defaultVideo && weblog.isVideoBlog")
			vue-plyr(v-if="weblog.defaultVideo.videoSource === 'youtube' || weblog.defaultVideo.videoSource === 'vimeo'" ref="plyr" :key="weblog.defaultVideo.videoId" :options="{'controls':['play', 'volume', 'progress', 'play-large', 'airplay', 'fullscreen', 'pip', 'mute'], 'disableContextMenu': false}")
				div(:data-plyr-provider="weblog.defaultVideo.videoSource" :data-plyr-embed-id="weblog.defaultVideo.videoId")
			video-hls(v-else-if="weblog.defaultVideo.videoSource === 'video'" :videoUrl="weblog.defaultVideo.videoId")
	.flow-left
		.weblog-item.mt-2(v-if="page === 1" )
			ws-content(:value="weblog.content")
			editorial-note(:editorialNote="weblog.editorialNote")

			.newsletter(v-if="isNL")
				strong.block.mb-1
					| {{$t('page.weblog.message:newsletter.title')}}
					nuxt-link.text-no-wrap(:to="localePath({name: 'newsletter'})" :title="$t('page.weblog.message:newsletter.link.title')")  {{$t('page.weblog.message:newsletter.link.text')}}
		template(v-if="weblog.category !== 'advertorial' && weblog.isRepliesVisible && isNL")
			// author
			template(v-if="page === 1" )
				v-divider.mt-3
				v-list-item.py-2(dense :to="isNL ? localePath({name: 'profile-slug', params:{slug: weblog.author.slug}}) : null")
					v-list-item-avatar
						v-avatar
							img(:src="`${weblog.author.avatar}?width=48`")
					v-list-item-content
						v-list-item-title.font-weight-bold.subtitle-2(href="#" :title="weblog.author.username") {{weblog.author.username}}
						v-list-item-subtitle.text-allow-wrap {{teamDescription}}
				v-divider.mb-3

		#reacties
		template(v-if="canReply && weblog.isReplyEnabled && weblog.isRepliesVisible && weblog.replies.nodes.length > 5 && page === 1")
			h2 {{$t('page.forum.topic:reply.title')}}
			reply-form.mt-6(compact :parentId="weblog.id" parentType="weblog" @submit-reply="newReply" v-bind:isposting.sync="skeleton")
			v-divider.mt-6.mb-3

		template(v-if="isNL && weblog.isRepliesVisible")
			template(v-if="pageCount > 1")
				v-pagination.mt-3.mb-6( v-model="page" :length="pageCount" :total-visible="10")
				v-divider.mb-3

			v-data-iterator.mb-6(:items="weblog.replies.nodes" :items-per-page="itemsPerPage" hide-default-footer :page.sync="page")
				template(#no-data)
					.mb-6
				template(#item="{item, index}")
					user-content(v-bind="item" :date="item.created_at" :quotable="!!$store.state.user.id" editable @quote="createQuote" type="reply" :adminPath="item.meta.adminPath" :isAuthor="item.user.username===weblog.author.username")
					template(v-if="index === 10 && weblog.replies.nodes.length > 12")
						ad(location="replies").mb-6
			template(v-if="skeleton")
				v-skeleton-loader.mb-3(type="paragraph" class="mx-auto")
				v-divider.mb-6

			template(v-if="pageCount > 1")
				v-pagination.mb-6( v-model="page" :length="pageCount" :total-visible="10")
				v-divider.mb-6

		template(v-if="isNL && weblog.isReplyEnabled")
			h2 {{$t('page.forum.topic:reply.title')}}
			reply-form#replyform(v-if="canReply" v-model="formContent" :parentId="weblog.id" parentType="weblog" @submit-reply="newReply" v-bind:isposting.sync="skeleton" ref="topicReplyForm")
			v-alert(v-if="!canReply" type="info" color="accent" text dense) {{cannotReplyReason}}
		v-alert.mb-6(v-else-if="weblog.repliesDisabledMessage && weblog.isRepliesVisible" type="info" color="accent" text dense) {{weblog.repliesDisabledMessage}}
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import EditorialNote from '@dengl/embeds/editorial-note/embed.vue';
import ReplyForm from '@/components/forum/reply-form';
import UserContent from '@/components/user-content/item.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getWeblog = gql`
	query weblogMessageById($slug: String, $page: Int) {
		weblog: weblog(slug: $slug) {
			id
			iso
			title
			slug
			replyCount
			content {
				...ContentDataFragment
			}
			photo
			author {
				id
				slug
				username
				teamDescription
				avatar
			}
			category
			publishDate
			editDate
			isPublic
			isPublished
			isReplyEnabled
			isRepliesVisible
			publishInNL
			publishInBE
			publishInDE
			repliesDisabledMessage
			isVideoBlog
			isPublishDateHidden
			isClosed
			editorialNote
			followerCount
			isFavorite
			defaultVideo {
				videoId
				videoSource
			}
			replies(page: $page) {
				nodes {
					...UserContentDetails
				}
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${UserContent.fragments}
	${Content.fragments}
`;

const ITEMS_PER_PAGE = 30;

export default {
	name: 'NewsMessage',
	components: { ReplyForm, UserContent, EditorialNote },
	layout: 'default',
	httpHeaders: async ({ app, route, error, redirect }) => {
		const weblog = await app.$graphClient
			.query({
				query: gql`
					query weblogRedirect($slug: String!) {
						weblog: weblogRedirect(slug: $slug) {
							meta {
								redirect
							}
							lastreply_at
							replyCount
						}
					}
				`,
				variables: {
					slug: route.path.split('/').slice(2).join('/')
				}
			})
			.then(({ data }) => {
				if (!data.weblog.meta) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				if (data.weblog.meta.redirect) {
					return redirect(302, data.weblog.meta.redirect);
				}

				return data.weblog;
			})
			.catch(error => {
				return app.httpError(500, null, 'news-slug-02', error);
			});

		if (
			(!route.query.page && weblog.replyCount > ITEMS_PER_PAGE) ||
			route.query.page * ITEMS_PER_PAGE < weblog.replyCount
		) {
			return {
				'Cache-Control':
					'public, max-age=300, must-revalidate, s-maxage=3600, stale-while-revalidate'
			};
		} else {
			return {
				'Cache-Control':
					'public, max-age=0, must-revalidate, s-maxage=300, stale-while-revalidate'
			};
		}
	},
	scrollToTop: true,
	nuxtI18n: {
		paths: {
			'nl-NL': '/nieuws/*',
			'nl-BE': '/nieuws/*',
			'de-DE': '/nachrichten/*'
		}
	},
	asyncData({ app, route, query, error }) {
		const variables = {
			slug: route.path.split('/').slice(2).join('/'),
			page: parseInt(query.page) || 1
		};

		return app.$graphClient
			.query({
				query: getWeblog,
				variables,
				errorPolicy: 'all',
				fetchPolicy: 'network-only'
			})
			.then(({ data, errors }) => {
				if (
					(data && !data.weblog) ||
					(data && data.weblog && data.weblog.category !== 'news')
				) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				if (errors) {
					throw errors[0];
				}

				const hreflang = {};

				if (data.weblog.publishInNL) {
					hreflang[
						'nl-NL'
					] = `https://${app.store.state.localeDomains['nl-NL']}/nieuws/${data.weblog.slug}`;
				}
				if (data.weblog.publishInBE) {
					hreflang[
						'nl-BE'
					] = `https://${app.store.state.localeDomains['nl-BE']}/nieuws/${data.weblog.slug}`;
				}
				if (data.weblog.publishInDE) {
					hreflang.de = `https://${app.store.state.localeDomains['de-DE']}/nieuws/${data.weblog.slug}`;
				}

				data.weblog.meta.hreflang = hreflang;
				data.weblog.meta.canonical = hreflang[data.weblog.iso];

				data.pageCount =
					Math.ceil(data.weblog.replyCount / ITEMS_PER_PAGE) || 1;

				data.weblog.meta.pagination = {
					total: data.pageCount,
					page: variables.page
				};

				data.weblog.meta.title = `${data.weblog.meta.title} - ${app.i18n.t(
					'page.news.meta.postfix'
				)}`;

				app.ads({
					sidebar: { visible: true },
					replies: { visible: true, type: 'reply' }
				});
				app.meta(data.weblog.meta);
				app.breadcrumbs({
					[app.i18n.t('page.news:breadcrumb')]: { name: 'news' },
					[data.weblog.title]: {
						name: 'news-slug',
						params: {
							0: data.weblog.slug
						}
					}
				});

				return {
					...data,
					...variables
				};
			})
			.catch(error => {
				return app.httpError(500, null, 'news-slug-01', error);
			});
	},
	data() {
		return {
			scrollToLastReply: false,
			formContent: '',
			page: 1,
			itemsPerPage: ITEMS_PER_PAGE,
			skeleton: false
		};
	},
	head() {
		let publisher;

		if (['nl-NL', 'nl-BE'].includes(this.$i18n.locale)) {
			publisher = {
				'@type': 'Organization',
				name: `Wintersport.${this.$i18n.locale.slice(3).toLowerCase()}`,
				logo: {
					'@type': 'ImageObject',
					url: `https://static.wintersport.nl/images/${this.$i18n.locale
						.slice(3)
						.toLowerCase()}/logo.png`
				}
			};
		} else if (this.$i18n.locale === 'de-DE') {
			publisher = {
				'@type': 'Organization',
				name: `Skiportal.de`,
				logo: {
					'@type': 'ImageObject',
					url: `https://static.wintersport.nl/images/de/logo.png`
				}
			};
		}

		const structuredData = {
			'@context': 'https://schema.org/',
			'@type': 'NewsArticle',
			description: this.weblog.meta.description,
			image: this.weblog.meta.image,
			headline: this.weblog.title,
			isAccessibleForFree: true,
			datePublished: this.$dayjs(this.weblog.publishDate).format(),
			mainEntityOfPage:
				'https://' +
				this.$store.state.localeDomains[this.$store.state.i18n.locale] +
				this.$route.path,
			author: {
				'@type': 'Person',
				name: this.weblog.author.username,
				url: `https://${
					this.$store.state.localeDomains[this.$store.state.i18n.locale]
				}/profiel/${this.weblog.author.slug}`
			},
			publisher
		};

		if (this.weblog.editDate) {
			structuredData.dateModified = this.$dayjs(this.weblog.editDate).format();
		}

		const structuredDataArray = [
			{
				innerHTML: JSON.stringify(structuredData),
				type: 'application/ld+json',
				hid: 'article-schema'
			}
		];

		return this.$lodash.merge(this.$structuredData(), {
			script: structuredDataArray
		});
	},
	computed: {
		canReply() {
			return !this.cannotReplyReason;
		},
		cannotReplyReason() {
			if (this.weblog.isClosed) {
				return this.$t('page.forum.topic:closed.explainer');
			}
			if (this.weblog.isOldWeblog) {
				return this.$t('page.forum.topic:closed.because.no.activity');
			}
			if (!this.weblog.isPublic) {
				return this.$t('page.forum.topic:no.replies.not.published.yet');
			}
			return false;
		},
		isNL() {
			return ['nl-NL', 'nl-BE'].includes(this.$i18n.locale);
		},
		teamDescription() {
			if (this.$i18n.locale === 'de-DE') {
				const userDescription = {
					roel: 'Roel ist schon seit 2009 unser beliebter Wettermann für das Skiwetter. Fast täglich schreibt er über Sonne, Schnee und Hintergründe rund um das Thema Skiurlaub.',
					rogier:
						'Rogier wohnt in den französischen Alpen. Sobald ein wenig Schnee liegt ist er draußen unterwegs, um Updates zu geben.',
					benb: 'Ben arbeitet seit über 20 Jahren im Tourismus und ist Spezialist für den Verkauf von Skireisen.',
					henri:
						'Ist Meteorologe und weiß zudem alles über neue Lifte und Projekte sowie Entwicklungen in den Skigebieten.',
					edo: 'Redakteur und Fotograf, der 4 Winter in den Alpen gelebt hat.',
					freerideguide:
						'Arbeitet seit Jahren als Skiführerin und berichten für uns aus Westtirol und Vorarlberg.', // Annelot
					sarahs:
						'Besucht von ihrem Wohnort in Tirol aus im Winter für uns die Skigebiete und gibt wertvolle Updates.'
				};

				if (Object.keys(userDescription).includes(this.weblog.author.slug)) {
					return userDescription[this.weblog.author.slug];
				}
			}

			return this.weblog.author.teamDescription;
		}
	},
	watch: {
		page: {
			handler(value) {
				const query = value === 1 ? {} : { page: value };
				this.$router.push({ query });
			}
		},
		'weblog.isFavorite'(val) {
			this.updateFavorite(val);
		}
	},
	watchQuery: ['page'],
	mounted() {
		if (this.$route.hash === '#reacties') {
			this.$vuetify.goTo('#reacties', {
				duration: 0,
				offset: 100
			});
		}
	},
	methods: {
		createQuote(reply) {
			this.formContent =
				'> ' +
				reply.content.rawMarkdown.split('\n').join('\n> ') +
				`\n> \n> § ${this.$t('reply:quote.posted.by', {
					user: reply.user.username,
					date: this.$dayjs(reply.date).format('DD MMM YYYY HH:mm')
				})}\n>\n`;

			this.$vuetify.goTo('#replyform');
			this.$refs.topicReplyForm.$refs.forumcontent.focusTextArea();
		},
		updateFavorite(val) {
			const mutation = val
				? gql`
						mutation ($weblogId: ID!) {
							weblogdata: addFavoriteWeblog(weblogId: $weblogId) {
								followerCount
							}
						}
				  `
				: gql`
						mutation ($weblogId: ID!) {
							weblogdata: removeFavoriteWeblog(weblogId: $weblogId) {
								followerCount
							}
						}
				  `;

			if (this.$store.state.user.id) {
				this.$graphClient
					.mutate({
						mutation,
						errorPolicy: 'all',
						variables: {
							weblogId: this.weblog.id
						}
					})
					.then(({ data, errors }) => {
						this.weblog.followerCount = data.weblogdata.followerCount;
						if (errors) {
							throw errors[0];
						}
					})
					.catch(_error => {
						this.$toast.error(this.$t('reply:upvote.error'));
					});
			}
		},
		newReply(reply) {
			if (this.page === this.pageCount) {
				this.weblog.replies.nodes.push(reply);
			} else {
				this.weblog.replyCount++;
				if (this.weblog.replyCount >= ITEMS_PER_PAGE) {
					this.$router.push({
						path: this.$route.path,
						query: { page: this.pageCount }
					});
				}
			}
		}
	}
};
</script>
